/**
 * Self-service address editor.
 *
 * The Settings tab "edit addresses" button opens this modal instead of the
 * native Shopify /account/addresses page. The form is pre-filled from
 * window.MillsDogDashboard.ME.customer.addresses[0] (default address) and
 * PATCHes the changes to /storefront/me/address on Laravel, which then
 * mirrors the update into Shopify via the existing CustomerService.
 *
 * Card data stays out of scope here — this is only address text fields.
 *
 * Depends on: dog-dashboard-api.js (window.MillsDogDashboard.api.updateAddress),
 * dog-dashboard-hydrate.js (window.MillsHydrate.refresh).
 */
(function (w, d) {
  "use strict";

  var M = w.MillsDogDashboard = w.MillsDogDashboard || {};

  var MODAL_ID = "mills-address-popup";

  var FIELDS = [
    { name: "firstName", label: "שם פרטי", type: "text", autocomplete: "given-name" },
    { name: "lastName", label: "שם משפחה", type: "text", autocomplete: "family-name" },
    { name: "address1", label: "רחוב ומספר בית", type: "text", autocomplete: "address-line1" },
    { name: "address2", label: "דירה / כניסה (אופציונלי)", type: "text", autocomplete: "address-line2" },
    { name: "city", label: "עיר", type: "text", autocomplete: "address-level2" },
    { name: "zip", label: "מיקוד", type: "text", autocomplete: "postal-code" },
    { name: "province", label: "מחוז (אופציונלי)", type: "text", autocomplete: "address-level1" },
    { name: "phone", label: "טלפון", type: "tel", autocomplete: "tel" },
  ];

  function readCurrentAddress() {
    var me = w.MillsDogDashboard && w.MillsDogDashboard.ME;
    var addrs = me && me.customer && Array.isArray(me.customer.addresses) ? me.customer.addresses : [];
    return addrs.length > 0 ? addrs[0] : {};
  }

  function buildModal(initial) {
    closeExistingModal();

    var overlay = d.createElement("div");
    overlay.id = MODAL_ID;
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "עריכת כתובת");
    overlay.style.cssText = [
      "position:fixed",
      "inset:0",
      "z-index:99999",
      "background:rgba(0,0,0,0.6)",
      "display:flex",
      "align-items:center",
      "justify-content:center",
      "padding:16px",
      "direction:rtl",
    ].join(";");

    var dialog = d.createElement("div");
    dialog.className = "mills-address-popup-dialog";
    dialog.style.cssText = "background:#fff;max-width:560px;width:100%;border-radius:8px;display:flex;flex-direction:column;max-height:90vh;overflow:hidden;";

    var header = d.createElement("div");
    header.style.cssText = "display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid #eee;";
    header.innerHTML = '<strong style="font-size:1.05rem;">עריכת כתובת ברירת מחדל</strong>' +
      '<button type="button" class="mills-address-popup-close" aria-label="סגירה" style="background:transparent;border:0;font-size:1.4rem;cursor:pointer;">×</button>';

    var form = d.createElement("form");
    form.className = "mills-address-popup-form";
    form.id = MODAL_ID + "-form";
    form.setAttribute("novalidate", "novalidate");
    form.style.cssText = "padding:16px 18px;overflow-y:auto;display:grid;grid-template-columns:1fr 1fr;gap:12px;";

    FIELDS.forEach(function (field, idx) {
      var wrap = d.createElement("label");
      wrap.style.cssText = "display:flex;flex-direction:column;font-size:0.92rem;color:#333;" + (idx === 2 || idx === 3 ? "grid-column:1/-1;" : "");
      var span = d.createElement("span");
      span.textContent = field.label;
      span.style.cssText = "margin-bottom:4px;";
      var input = d.createElement("input");
      input.type = field.type;
      input.name = field.name;
      input.autocomplete = field.autocomplete;
      input.value = initial && initial[field.name] != null ? String(initial[field.name]) : "";
      input.style.cssText = "border:1px solid #ccc;border-radius:6px;padding:8px 10px;font-size:1rem;";
      wrap.appendChild(span);
      wrap.appendChild(input);
      form.appendChild(wrap);
    });

    var status = d.createElement("div");
    status.className = "mills-address-popup-status";
    status.style.cssText = "padding:0 18px;color:#b00;min-height:1.2em;";

    var footer = d.createElement("div");
    footer.style.cssText = "display:flex;gap:8px;justify-content:flex-end;padding:14px 18px;border-top:1px solid #eee;";
    var cancel = d.createElement("button");
    cancel.type = "button";
    cancel.className = "btn btn-secondary mills-address-popup-cancel";
    cancel.textContent = "ביטול";
    var save = d.createElement("button");
    save.type = "submit";
    save.className = "btn mills-address-popup-save";
    // The footer (and this button) live outside <form>, so associate the
    // submit button with the form by id — otherwise clicking it fires nothing.
    save.setAttribute("form", MODAL_ID + "-form");
    save.textContent = "שמירה";
    footer.appendChild(cancel);
    footer.appendChild(save);

    dialog.appendChild(header);
    dialog.appendChild(form);
    dialog.appendChild(status);
    dialog.appendChild(footer);
    overlay.appendChild(dialog);
    d.body.appendChild(overlay);

    function close() {
      overlay.remove();
    }

    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    header.querySelector(".mills-address-popup-close").addEventListener("click", close);
    cancel.addEventListener("click", close);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      status.textContent = "";
      save.disabled = true;
      save.textContent = "שומר…";

      var payload = {};
      FIELDS.forEach(function (field) {
        var input = form.querySelector('input[name="' + field.name + '"]');
        if (input) payload[field.name] = input.value;
      });

      submitUpdate(payload).then(function () {
        updateAddressBox(payload);
        refreshMeSnapshot();
        showToastIfAvailable("הכתובת עודכנה", true);
        close();
      }).catch(function (err) {
        save.disabled = false;
        save.textContent = "שמירה";
        var msg = (err && (err.body && err.body.message)) || (err && err.message) || "השמירה נכשלה. נסה שוב.";
        status.textContent = msg;
      });
    });

    var firstField = form.querySelector("input");
    if (firstField) setTimeout(function () { firstField.focus(); }, 60);
  }

  function closeExistingModal() {
    var existing = d.getElementById(MODAL_ID);
    if (existing) existing.remove();
  }

  function submitUpdate(fields) {
    var api = w.MillsDogDashboard && w.MillsDogDashboard.api;
    if (!api || typeof api.updateAddress !== "function") {
      return Promise.reject(new Error("dog-dashboard-api.js הוא לא טעון — לא ניתן לעדכן כתובת."));
    }
    return api.updateAddress(fields);
  }

  // Writes the just-saved values straight into the dashboard's default-address
  // box. /me's customer.addresses is not a reliable source for this box, so we
  // render from the values the customer submitted (and the server accepted).
  function updateAddressBox(fields) {
    var box = d.querySelector('[data-hydrate="default-address"]');
    if (!box || !fields) return;
    if (w.MillsHydrate && typeof w.MillsHydrate.renderDefaultAddress === "function") {
      w.MillsHydrate.renderDefaultAddress(box, fields);
    }
  }

  // Re-fetch /me and re-run hydration so the default-address box reflects
  // the saved address without a page reload.
  function refreshMeSnapshot() {
    if (w.MillsHydrate && typeof w.MillsHydrate.refresh === "function") {
      try { w.MillsHydrate.refresh(); } catch (_e) { /* ignore */ }
      return;
    }
    if (w.MillsHydrate && typeof w.MillsHydrate.invalidateCache === "function") {
      w.MillsHydrate.invalidateCache();
    }
  }

  function showToastIfAvailable(message, ok) {
    var t = w.MillsDogDashboard && w.MillsDogDashboard.showToast;
    if (typeof t === "function") {
      try { t(message, ok); } catch (_e) { /* ignore */ }
    }
  }

  /** Opens the address edit modal pre-filled with the customer's current default address. */
  M.openAddressEditPopup = function () {
    buildModal(readCurrentAddress());
  };

  // Wire the Settings tab button (data-action="open-mills-address-popup")
  d.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="open-mills-address-popup"]');
    if (!btn) return;
    e.preventDefault();
    M.openAddressEditPopup();
  });
})(window, document);
